/* eslint-disable import/exports-last */
import classNames from 'classnames'
import styles from './TextLink.module.css'
import { type ForwardedRef, forwardRef } from 'react'
import { TextLinkProps } from './types'
// eslint-disable-next-line import/exports-last
export type HeadlessLinkProps = Pick<TextLinkProps, 'kind' | 'className' | 'largerClickArea' | 'size'>
export function headlessLinkProps<T extends HeadlessLinkProps>({
  kind = 'default',
  className,
  largerClickArea,
  size = 'default',
  ...props
}: T) {
  return {
    ...props,
    className: classNames(styles.link, styles[`${kind}`], className, {
      [styles.largerClickArea!]: largerClickArea,
      [styles.small as string]: size === 'small',
    }),
  }
}

const TextLink = forwardRef(function TextLink({ href, ...props }: TextLinkProps, ref: ForwardedRef<HTMLAnchorElement>) {
  const { children, ...props_ } = headlessLinkProps(props)
  return (
    <a ref={ref} href={href} {...props_}>
      {children}
    </a>
  )
})

export default TextLink
